<template>
  <v-container style="max-width: 1800px !important">
    <div class="pa-3 ma-3">
      <v-alert-dialog ref="alert"> </v-alert-dialog>

      <v-dialog
        v-model="dialogValidate"
        max-width="80%"
        persistent
      >
        <v-card>
          <v-card-title>
            Validación de Documentación
          </v-card-title>
          
          <v-card-text v-if="loadingDetails" class="text-center py-8">
            <v-progress-circular
              indeterminate
              size="128"
              width="4"
              class="mb-3"
              color="primary"
            ></v-progress-circular>
            <div class="text-subtitle-2">
              Cargando detalles del empleado ...
            </div>
          </v-card-text>
          <v-card-text v-else>
            <v-row class="pa-0 ma-0">
              <v-col cols="12" class="pa-0 ma-0 text-center">
                <div class="text-subtitle-1 font-weight-bold">
                  <v-icon>mdi-account</v-icon>
                  Datos Personales
                </div>
              </v-col>

              <!-- DATOS PERSONALES -->
              <v-col cols="3">
                <div class="text-subtitle-2">Nombre:</div>
                <div>{{ editedItem.nombre }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2">Apellido paterno:</div>
                <div>{{ editedItem.apellido_paterno }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2">Apellido materno:</div>
                <div>{{ editedItem.apellido_materno }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2">Fecha de nacimiento:</div>
                <div>{{ editedItem.fecha_nacimiento_beauty || editedItem.fecha_nacimiento }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2">Género:</div>
                <div>{{ editedItem.genero == 0 ? 'Femenino' : 'Masculino' }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2">Estado civil:</div>
                <div>{{ editedItem.nombre_estado_civil || 'N/D' }}</div>
              </v-col>

              <!-- IDENTIFICACIONES -->
              <v-col cols="3">
                <div class="text-subtitle-2">CURP:</div>
                <div>{{ editedItem.curp_valor }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2">RFC:</div>
                <div>{{ editedItem.rfc_valor }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2">Número de Seguridad Social:</div>
                <div>{{ editedItem.nss_valor || 'N/D' }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2">No. trabajador (NOI):</div>
                <div>{{ editedItem.noi_numero_trabajador || 'N/D' }}</div>
              </v-col>
              <v-col cols="6">
              </v-col>
              
              <v-col
                cols="12"
                class="pb-0 mb-0 text-center"
              >
                <div class="text-subtitle-1 font-weight-bold">
                  <v-icon>
                    mdi-phone
                  </v-icon>
                  Datos de Contacto
                </div>
              </v-col>

              <v-col cols="6">
                <div class="text-subtitle-2">Dirección:</div>
                <div>{{ editedItem.direccion || 'N/D' }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2"># Exterior:</div>
                <div>{{ editedItem.num_exterior || 'N/D' }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2"># Interior:</div>
                <div>{{ editedItem.num_interior || 'N/D' }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2">Colonia:</div>
                <div>{{ editedItem.colonia || 'N/D' }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2">Código postal:</div>
                <div>{{ editedItem.cp || 'N/D' }}</div>
              </v-col>

              <v-col cols="3">
                <div class="text-subtitle-2">Estado:</div>
                <div>{{ editedItem.nombre_estado || 'N/D' }}</div>
              </v-col>
                          
              <v-col cols="3">
                <div class="text-subtitle-2">Município:</div>
                <div>{{ editedItem.nombre_municipio || 'N/D' }}</div>
              </v-col>

              <v-col cols="6">
                <div class="text-subtitle-2">Teléfono de contacto:</div>
                <div>{{ editedItem.telefono || 'N/D' }}</div>
              </v-col>

              <v-col cols="6">
                <div class="text-subtitle-2">Email de contacto:</div>
                <div>{{ editedItem.email || 'N/D' }}</div>
              </v-col>

              <v-col cols="6">
                <div class="text-subtitle-2">Nombre completo del contacto de emergencia:</div>
                <div>{{ editedItem.nombre_contacto_emergencia || 'N/D' }}</div>
              </v-col>

              <v-col cols="6">
                <div class="text-subtitle-2">Número de celular del contacto de emergencia:</div>
                <div>{{ editedItem.telefono_contacto_emergencia || 'N/D' }}</div>
              </v-col>

              <v-col
                cols="12"
                class="pb-0 mb-0 text-center"
              >
                <div class="text-subtitle-1 font-weight-bold">
                  <v-icon>
                    mdi-briefcase
                  </v-icon>
                  Información Laboral
                </div>
              </v-col>

              <v-col cols="4">
                <div class="text-subtitle-2">Puesto:</div>
                <div>{{ editedItem.nombre_puesto }}</div>
              </v-col>

              <v-col cols="4">
                <div class="text-subtitle-2">Fecha de alta:</div>
                <div>{{ editedItem.fecha_alta }}</div>
              </v-col>

              <v-col cols="4">
                <div class="text-subtitle-2">Sueldo quincenal bruto:</div>
                <div>{{ editedItem.sueldo_bruto_quincenal != null ? formatMoney(editedItem.sueldo_bruto_quincenal) : 'N/D' }}</div>
              </v-col>

              <v-col
                cols="12"
                class="pb-0 mb-0 text-center"
              >
                <div class="text-subtitle-1 font-weight-bold">
                  <v-icon>
                    mdi-scale-balance
                  </v-icon>
                  Información Legal/Fiscal
                </div>
              </v-col>

              <v-col cols="4">
                <div class="text-subtitle-2">¿Tiene activo el régimen de sueldos y salarios e ingresos asimilados a salarios?:</div>
                <div>{{ (editedItem.regimen_sueldos != null) ? (editedItem.regimen_sueldos ? 'Sí' : 'No') : 'N/D' }}</div>
              </v-col>

              <v-col cols="4">
                <div class="text-subtitle-2">¿Tiene algún crédito u obligación legal que afecte su nómina?:</div>
                <div>{{ (editedItem.tiene_credito != null) ? (editedItem.tiene_credito ? 'Sí' : 'No') : 'N/D' }}</div>
              </v-col>

              <v-col cols="4">
                <div class="text-subtitle-2">Tipo de crédito u obligación legal:</div>
                <div>{{ (editedItem.nombres_tipo_credito != null && editedItem.nombres_tipo_credito.length > 0) ? (editedItem.nombres_tipo_credito || []).join(', ') : 'N/A' }}</div>
              </v-col>

              <v-col cols="12">
                <v-simple-table dense class="mb-2">
                  <thead>
                    <tr>
                      <th class="text-left" style="width: 33.33%">Nombre completo del beneficiario</th>
                      <th class="text-left" style="width: 33.33%">Número de celular del beneficiario</th>
                      <th class="text-left" style="width: 33.33%">Parentesco del beneficiario</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, i) in editedItem.beneficiarios" :key="'beneficiario-' + i">
                      <td>
                        {{ row.nombre_completo }}
                      </td>
                      <td>
                        {{ row.telefono }}
                      </td>
                      <td>
                        {{ row.nombre_parentesco }}
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>

              <v-col cols="12" class="pb-0 mb-0 text-center">
                <div class="text-subtitle-1 font-weight-bold">
                  <v-icon class="cuentas-bancarias-icon">mdi-bank-outline</v-icon>
                  Cuentas bancarias
                </div>
              </v-col>

              <template v-if="cuentasBancarias.length">
                <v-col
                  v-for="cuenta in cuentasBancarias"
                  :key="cuenta.id_empleado_cuenta_nacional"
                  cols="12"
                  class="cuenta-validacion-row"
                >
                  <v-row class="ma-0 pa-0">
                      <v-col cols="3">
                        <div class="text-subtitle-2">Tipo de cuenta:</div>
                        <div>{{ cuenta.tipo_cuenta_nombre || 'Nómina' }}</div>
                      </v-col>

                      <v-col cols="3">
                        <div class="text-subtitle-2">Banco:</div>
                        <div>{{ cuenta.banco || 'N/D' }}</div>
                      </v-col>

                      <v-col cols="3">
                        <div class="text-subtitle-2">Moneda:</div>
                        <div>{{ cuenta.moneda || 'N/D' }}</div>
                      </v-col>

                      <v-col cols="3">
                        <div class="text-subtitle-2">Beneficiario:</div>
                        <div>{{ cuenta.nombre_beneficiario || 'N/D' }}</div>
                      </v-col>

                      <v-col cols="3">
                        <div class="text-subtitle-2">CLABE interbancaria:</div>
                        <div>{{ cuenta.clave_int || 'N/D' }}</div>
                      </v-col>

                      <v-col cols="3">
                        <div class="text-subtitle-2">Cuenta:</div>
                        <div>{{ cuenta.cuenta || 'N/D' }}</div>
                      </v-col>

                      <v-col cols="3">
                        <div class="text-subtitle-2">CIE:</div>
                        <div>{{ cuenta.cie || 'N/D' }}</div>
                      </v-col>

                      <v-col cols="3">
                        <div class="text-subtitle-2">Referencia:</div>
                        <div>{{ cuenta.referencia || 'N/D' }}</div>
                      </v-col>

                      <v-col cols="12" class="pt-0 text-center">
                        <v-btn-toggle
                          v-model="validacionesCuentas[cuenta.id_empleado_cuenta_nacional].validado"
                          class="mt-2"
                        >
                          <v-btn outlined color="green" :value="true">
                            <v-icon left small color="green">mdi-check</v-icon>
                            Cuenta válida
                          </v-btn>
                          <v-btn outlined color="red" :value="false">
                            <v-icon left small color="red">mdi-close</v-icon>
                            Cuenta no válida
                          </v-btn>
                        </v-btn-toggle>
                      </v-col>

                      <v-col
                        v-if="validacionesCuentas[cuenta.id_empleado_cuenta_nacional].validado === false"
                        cols="12"
                      >
                        <v-textarea
                          v-model="validacionesCuentas[cuenta.id_empleado_cuenta_nacional].comentario"
                          outlined
                          dense
                          hide-details
                          rows="1"
                          auto-grow
                          label="Motivo de rechazo de la cuenta *"
                        />
                      </v-col>
                  </v-row>
                </v-col>
              </template>

              <v-col v-else cols="12">
                <v-alert type="error" outlined dense class="mb-0">
                  El empleado no ha proporcionado una cuenta de nómina.
                </v-alert>
              </v-col>

              <v-col
                v-if="editedItem.requisitos != null && editedItem.requisitos.length > 0"
                cols="12"
                class="pa-0 ma-0 text-center"
              >
                <br>
                <div class="text-subtitle-1 font-weight-bold">
                  <v-icon>
                    mdi-file-document-outline
                  </v-icon>
                  Documentación
                </div>
              </v-col>
              <template
                v-for="expediente_requisito in editedItem.requisitos"
              >
                <v-col
                  :key="expediente_requisito.codigo"
                  cols="6"
                >
                  <template v-if="expediente_requisito.tipo_documento == 1">
                    <VFileInputError
                      v-if="expediente_requisito.documento != null"
                      :file-name="expediente_requisito.documento"
                      :label="expediente_requisito.nombre"
                      download-url="/api/RecursosHumanos/DescargarDocumento"
                      :token="token"
                      :status="expediente_requisito.validado"
                      :previous-note="expediente_requisito.anomalia_anterior"
                      :note="expediente_requisito.comentario"
                      @change="onDocumentoChange(expediente_requisito, $event)"
                    />

                    <div v-else>
                      <div class="text-subtitle-2">{{expediente_requisito.nombre}}:</div>
                       <div>Documento no Proporcionado</div>
                    </div>

                    <div v-if="expediente_requisito.nota != null" class="text-caption note-style">Nota: {{expediente_requisito.nota}}</div>
                  </template>

                  <template v-else>
                    <div class="text-subtitle-2">{{ expediente_requisito.nombre }}:</div>
                     <v-row class="pa-0 ma-0">
                      <v-col cols="auto" class="pa-0 ma-0">
                        <v-check
                          v-model="expediente_requisito.validado"
                          class="pa-0 ma-0"
                          dense
                          hide-details
                          indeterminate
                        >
                        </v-check>
                      </v-col>
                      <v-col class="pa-0 ma-0 align-self-center">
                          {{expediente_requisito.documento}}
                      </v-col>
                      <v-col 
                        v-if="expediente_requisito.validado == false"
                        cols="12"
                        class="ma-0 pa-0 pt-3"
                      >
                        <v-textarea
                          v-model="expediente_requisito.comentario"
                          outlined
                          dense
                          hide-details
                          rows="1"
                          auto-grow
                          :label="`Motivo de Rechazo - ${expediente_requisito.nombre}`"
                        >
                        </v-textarea>
                      </v-col>
                    </v-row>
                    <div v-if="expediente_requisito.nota != null" class="text-caption note-style">Nota: {{expediente_requisito.nota}}</div>
                    <div v-if="expediente_requisito.anomalia_anterior != null" class="text-caption note-style red--text">Motivo de Rechazo: {{expediente_requisito.anomalia_anterior}}</div>
                  </template>
                </v-col>
              </template>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green"
              text
              @click="closeDialogValidate"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="red"
              text
              @click="saveDialogValidation"
              :loading="loadingSave"
              class="white--text"
              >
                Guardar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-row>
        <v-col cols="12">
          <v-data-table
            :loading="loading"
            :headers="headers"
            :items="items"
          >
            <template v-slot:[`item.nombre_puesto`]="{ item }">
              <div>{{ item.nombre_puesto || 'N/D' }}</div>
              <div class="text-caption grey--text">
                {{ item.fecha_desde || 'N/D' }} - {{ item.fecha_hasta || 'Indefinido' }}
              </div>
            </template>
            <template v-slot:[`item.expediente_validado`]="{ item }">
              <VTooltipIconV2
                v-if="item.pendiente_carga"
                color="gray"
                icon="mdi-timer-sand"
                :tooltip-text="`Pendiente Carga de Documentación`"
              />
              <VTooltipIconV2
                v-else-if="!item.expediente_validado"
                color="orange"
                icon="mdi-file-find-outline"
                :tooltip-text="`En Espera de Validación de Documentacion`"
              />
              <VTooltipIconV2
                v-else
                color="green"
                icon="mdi-check"
                :tooltip-text="`Documentación Validada por ${item.expediente_validado_por} desde ${item.expediente_validado_fecha}`"
              />
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon
                v-if="!item.pendiente_carga && !item.expediente_validado"
                class="mr-2"
                small
                @click="openDialogValidate(item)"
              >
                mdi-check-bold
              </v-icon>
           </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import axios from 'axios'
import { mapState } from "vuex";
import VAlertDialog from "@/components/VAlertDialog.vue";
import VTooltipIconV2 from '@/components/VTooltipIconV2.vue';
//import VCheck from '@/components/VCheck.vue';
import VFileInputError from '@/components/VFileInputError.vue';
import { v4 } from 'uuid';

export default {
  components: {
    VAlertDialog,
    VTooltipIconV2,
    //VCheck,
    VFileInputError
  },
  data: () => ({
    loading: false,
    items: [],
    headers: [
      {
        text: "# Empleado",
        value: "codigo_empleado",
        align: "center",
      },
      {
        text: "Nombre",
        value: "nombre",
        align: "center",
      },
      {
        text: "Apellido paterno",
        value: "apellido_paterno",
        align: "center",
      },
      {
        text: "Apellido materno",
        value: "apellido_materno",
        align: "center",
      },
      {
        text: "Puesto",
        value: "nombre_puesto",
        align: "center",
      },
      {
        text: "RFC",
        value: "rfc_valor",
        align: "center",
      },
      {
        text: "Expediente",
        value: "expediente_validado",
        align: "center",
      },
      {
        text: "Acciones",
        value: "actions",
        sortable: false,
        align: "center",
      },
    ],
    editedItem: {
      id_empleado: null,
      id_empleado_puesto: null,
      codigo_empleado: null,
      nombre: null,
      apellido_paterno: null,
      apellido_materno: null,
      fecha_nacimiento: null,
      fecha_nacimiento_beauty: null,
      genero: 0,
      id_estado_civil: null,
      nombre_estado_civil: null,
      curp_valor: null,
      rfc_valor: null,
      nss_valor: null,
      noi_numero_trabajador: null,
      direccion: null,
      num_exterior: null,
      num_interior: null,
      colonia: null,
      cp: null,
      id_estado: null,
      nombre_estado: null,
      id_municipio: null,
      nombre_municipio: null,
      telefono: null,
      email: null,
      nombre_contacto_emergencia: null,
      telefono_contacto_emergencia: null,
      id_puesto: null,
      nombre_puesto: null,
      fecha_alta: null,
      sueldo_bruto_quincenal: null,
      regimen_sueldos: null,
      tiene_credito: null,
      ids_tipo_credito: null,
      nombres_tipo_credito: [],
      beneficiarios: [],
      pendiente_carga: true,
      expediente_validado: false,
      expediente_validado_fecha: null,
      expediente_validado_por: null,
      cuentas_bancarias: [],
      requisitos: []
    },
    defaultEditedItem: {
      id_empleado: null,
      id_empleado_puesto: null,
      codigo_empleado: null,
      nombre: null,
      apellido_paterno: null,
      apellido_materno: null,
      fecha_nacimiento: null,
      fecha_nacimiento_beauty: null,
      genero: 0,
      id_estado_civil: null,
      nombre_estado_civil: null,
      curp_valor: null,
      rfc_valor: null,
      nss_valor: null,
      noi_numero_trabajador: null,
      direccion: null,
      num_exterior: null,
      num_interior: null,
      colonia: null,
      cp: null,
      id_estado: null,
      nombre_estado: null,
      id_municipio: null,
      nombre_municipio: null,
      telefono: null,
      email: null,
      nombre_contacto_emergencia: null,
      telefono_contacto_emergencia: null,
      id_puesto: null,
      nombre_puesto: null,
      fecha_alta: null,
      sueldo_bruto_quincenal: null,
      regimen_sueldos: null,
      tiene_credito: null,
      ids_tipo_credito: null,
      nombres_tipo_credito: [],
      beneficiarios: [],
      pendiente_carga: true,
      expediente_validado: false,
      expediente_validado_fecha: null,
      expediente_validado_por: null,
      cuentas_bancarias: [],
      requisitos: []
    },
    loadingSave: false,
    urlBase: "/api/RecursosHumanos/DescargarDocumento",
    dialogValidate: false,
    loadingDetails: false,
    validacionesCuentas: {},
  }),
  mounted() {
    this.getItems();
  },
  methods: {
    uuidv4(){
      return v4();
    },
    getItems() {
      this.loading = true;
      axios
      .get('/RecursosHumanos/ListarEmpleadosPorValidar')
      .then(response => {
        this.items = response.data;
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.loading = false;
      })
    },
    validEmployee(){
      return true;
    },
    inicializarValidacionesCuentas() {
      const validaciones = {};
      this.cuentasBancarias.forEach(cuenta => {
        validaciones[cuenta.id_empleado_cuenta_nacional] = {
          validado: null,
          comentario: ''
        };
      });
      this.validacionesCuentas = validaciones;
    },
    openDialogValidate(editItem) {
      this.dialogValidate = true;

      this.loadingDetails = true;
      axios
      .get(`/RecursosHumanos/DetalleEmpleadoPuesto/${editItem.id_empleado_puesto}`)
      .then(response => {
        this.editedItem = {
          ...response.data,
          id_empleado_puesto: editItem.id_empleado_puesto
        };
        this.inicializarValidacionesCuentas();
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        this.loadingDetails = false;
      })

    },
    closeDialogValidate() {
      this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.validacionesCuentas = {};
      this.loadingDetails = false;
      this.dialogValidate = false;
    },
    validateValidation(){
      if (this.cuentasBancarias.length === 0) {
        this.$refs.alert.setMessage('', 'El empleado debe proporcionar al menos una cuenta bancaria antes de validar el expediente.');
        this.$refs.alert.open();
        return false;
      }

      for (let i = 0; i < this.cuentasBancarias.length; i++) {
        const cuenta = this.cuentasBancarias[i];
        const validacion = this.validacionesCuentas[cuenta.id_empleado_cuenta_nacional];
        if (!validacion || validacion.validado == null) {
          this.$refs.alert.setMessage('', 'Debe indicar si cada cuenta bancaria es válida o no válida.');
          this.$refs.alert.open();
          return false;
        }

        if (validacion.validado === false && (!validacion.comentario || validacion.comentario.trim().length === 0)) {
          this.$refs.alert.setMessage('', 'Debe indicar el motivo de rechazo de cada cuenta no válida.');
          this.$refs.alert.open();
          return false;
        }
      }

      for (let i = 0; i < this.editedItem.requisitos.length; i++) {
        var requisito = this.editedItem.requisitos[i];
        
        if(requisito.documento && requisito.validado == null){
          this.$refs.alert.setMessage("", `Debe de indicar si ${requisito.nombre.replace(' *', '')} es Valido o No.`);
          this.$refs.alert.open();
          return false;
        }

        if(requisito.documento && requisito.validado == false && (!requisito.comentario || requisito.comentario.length <=0)){
          this.$refs.alert.setMessage("", `Debe de indicar el motivo por el cual no es valido ${requisito.nombre.replace(' *', '')}`);
          this.$refs.alert.open();
          return false;
        }
      }
      return true;
    },
    saveDialogValidation(){
      if (!this.validateValidation()) return;

      this.loadingSave = true;

      const documentos = this.editedItem.requisitos.filter(x => x.documento).map(x => {
        return {
          id_expediente_documento: x.id_expediente_documento,
          validado: x.validado,
          comentario: x.comentario
        };
      });

      const cuentas_bancarias = this.cuentasBancarias.map(cuenta => {
        const validacion = this.validacionesCuentas[cuenta.id_empleado_cuenta_nacional];
        return {
          id_empleado_cuenta_nacional: cuenta.id_empleado_cuenta_nacional,
          validado: validacion.validado,
          comentario: validacion.validado ? null : validacion.comentario.trim()
        };
      });

      axios
      .put(`/RecursosHumanos/ValidarEmpleado/${this.editedItem.id_empleado_puesto}`, {
        documentos,
        cuentas_bancarias
      })
      .then(response => {
        this.closeDialogValidate();
        this.getItems();
        if (response.data?.validado === false) {
          this.$refs.alert.setMessage('Expediente pendiente', response.data.mensaje
            || 'La revisión se guardó, pero el expediente continúa pendiente.');
          this.$refs.alert.open();
        }
      })
      .catch(error => {
        const mensaje = error.response?.data?.msg || error.response?.data?.Msg
          || 'No se pudo guardar la revisión del expediente. Inténtelo nuevamente.';
        this.$refs.alert.setMessage('No se guardó la revisión', mensaje);
        this.$refs.alert.open();
      })
      .finally(() => {
        this.loadingSave = false;
      });

      /*

      // Convierte los campos de `this.editedItem` en entradas de `FormData`
      const formData = new FormData();
      Object.keys(this.validatedItem).forEach(key => {
        if(this.validatedItem[key] != null) formData.append(key, this.validatedItem[key]);
      });

      axios({
        method: 'PUT',
        url: `/RecursosHumanos/ValidarEmpleado`,
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' } // Asegura el tipo de contenido
      })
      .then(() => {
        this.getItems();
        this.closeDialogValidate();
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.loadingSave = false;
      });
      */
    },
    onDocumentoChange(requisito, payload) {
      requisito.validado   = payload.status;
      requisito.comentario = payload.note;
    },
    formatMoney(number) {
      if(!number) return "";
      // Convierte el número a un string con dos decimales
      let numberString = number.toFixed(2);

      // Usa una expresión regular para agregar comas cada tres dígitos
      let formattedNumber = "$"+numberString.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      return formattedNumber;
    },
  },
  computed: {
    ...mapState(['token']),
    cuentasBancarias() {
      return Array.isArray(this.editedItem.cuentas_bancarias) ? this.editedItem.cuentas_bancarias : [];
    },
  }
};
</script>


<style scoped>
.red-row {
  background-color: red !important;
  color: white;
}

.cuenta-validacion-row {
  margin: 8px 0;
  padding: 12px 0;
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
}

.cuentas-bancarias-icon {
  color: inherit !important;
}
</style>
